import { actionTree, mutationTree } from 'typed-vuex'
import { convertToSentListCard, setState } from '~/lib/utils/store'
import { SubSource } from '~/plugins/mixpanel/values'
import { APPLICATION_LIST, SCHOLARSHIP_LIST } from '~/store/cardList'
import { SENT_TAB } from '~/store/sideBar'

export const typesName = {
  text: 'texts',
  file: 'files',
  image: 'images',
  input: 'inputs',
  survey: 'survey',
  'special-eligibility': 'specialEligibility'
}

const idNames = {
  text: 'requirementTextId',
  file: 'requirementFileId',
  image: 'requirementImageId',
  input: 'requirementInputId',
  survey: 'requirementId',
  'special-eligibility': 'requirementId'
}

export const state = () => ({
  scholarships: {} as {[key: string]: Scholarship.Details | Scholarship.DetailsSent},
  isScholarshipSending: false,
  latestAppliedScholarship: null as Scholarship.General | null,
  routerViewKey: null
})

export const mutations = mutationTree(state, {
  setState
})

export const actions = actionTree(
  { state, mutations },
  {
    getDetails({ commit, state }, { cardId, tabName, force }: { cardId: string | number, tabName: string, force?: boolean }): Promise<any> {
      if (!force && state.scholarships[cardId]) { return Promise.resolve(state.scholarships[cardId]) }

      const resourceName = tabName === SENT_TAB ? 'application' : 'scholarship'

      return this.$api.scholarship[resourceName]({ id: cardId })
        .then((res) => {
          let card = res.data.data

          if (tabName === SENT_TAB) {
            const scholarship = card.scholarship

            scholarship.applicationCount = card.applicationCount
            scholarship.applicationCap = card.applicationCap ?? null
            scholarship.capUrgency = card.capUrgency ?? null
            scholarship.requirementOptionalCount = card.requirementOptionalCount
            scholarship.requirementTotalCount = card.requirementTotalCount

            card = {
              scholarship,
              requirements: card.scholarship.requirements,
              applicationRequirements: card.scholarship.application
            }
          }

          commit('setState', { stateName: `scholarships.${cardId}`, data: card })
          this.app.$accessor.requirements.setRequirement({
            scholarshipId: cardId,
            requirements: card.requirements,
            applications: card.applicationRequirements
          })

          return { ...card, res }
        })
    },
    getRelatedApplication({ state }, { scholarshipId, requirementId, requirementType }): any {
      const activeCard = state.scholarships[scholarshipId]

      if (!activeCard) { return null }

      // @ts-ignore
      const application = activeCard.applicationRequirements
      const types = typesName[requirementType]

      if (application && Array.isArray(application[types])) {
        const idName = idNames[requirementType]

        for (let i = 0; i < application[types].length; i++) {
          if (application[types][i][idName] === requirementId) {
            return application[types][i]
          }
        }
      }

      return null
    },

    apply(
      { state, commit },
      {
        scholarship,
        subSource
      }: {
        scholarship: { scholarshipId: Scholarship.General['scholarshipId'] }
        subSource: SubSource
      }
    ): Promise<void> {
      const { scholarshipId } = scholarship || {}

      commit('setState', { stateName: 'isScholarshipSending', data: true })

      return this.$api.scholarship.apply({ scholarshipId, subSource })
        .then((response) => {
          if (response.data.data) {
            const cardId = response.data.data.scholarshipId
            const application = response.data.data
            const card = this.app.$accessor.cardList.getListItem({ storeName: SCHOLARSHIP_LIST, id: cardId })

            commit('setState', { stateName: 'latestAppliedScholarship', data: card })

            this.app.$accessor.cardList.setListItem({
              storeName: APPLICATION_LIST,
              item: convertToSentListCard(card, application)
            })
            this.app.$accessor.cardList.removeListItem({ storeName: SCHOLARSHIP_LIST, id: card.scholarshipId })

            delete state.scholarships[cardId]
          }

          // remove sent requirements from requirements store
          this.app.$accessor.requirements.removeRequirement({ scholarshipId })
        })
        .catch((err) => {
          this.$sentry.captureException(Error('Scholarship apply error.'), { extra: err.response.data })
          throw err
        })
        .finally(() => commit('setState', { stateName: 'isScholarshipSending', data: false }))
    }
  }
)
